import { render, staticRenderFns } from "./TruckingRate.vue?vue&type=template&id=790123ba&scoped=true&"
import script from "./TruckingRate.vue?vue&type=script&lang=js&"
export * from "./TruckingRate.vue?vue&type=script&lang=js&"
import style0 from "./TruckingRate.vue?vue&type=style&index=0&id=790123ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790123ba",
  null
  
)

export default component.exports